import { render, staticRenderFns } from "./UserSpouseRepeater.vue?vue&type=template&id=a2703624&scoped=true"
import script from "./UserSpouseRepeater.vue?vue&type=script&lang=js"
export * from "./UserSpouseRepeater.vue?vue&type=script&lang=js"
import style0 from "./UserSpouseRepeater.vue?vue&type=style&index=0&id=a2703624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2703624",
  null
  
)

export default component.exports